// extracted by mini-css-extract-plugin
export default {"ricosDisabled":"ARQcy0","checkbox":"sum2Js"};